import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination } from "swiper/modules";

import CambridgeIcon from "../../../../../../../assets/icons/Cambridge icon.svg";
import JuniorIcon from "../../../../../../../assets/icons/Junior icon.svg";
import KidsBoxIcon from "../../../../../../../assets/icons/Kids Box icon.svg";
import SuperSafariIcon from "../../../../../../../assets/icons/Super Safari icon.svg";
import BadgeApproved from "../../../../../../../assets/icons/Badge Approved.svg";
import BadgeError from "../../../../../../../assets/icons/Badge Error.svg";
import { useTranslation } from "react-i18next";

const CardGroups = ({ groups, bigSlidesPerView = 3, smallSlidesPerView = 2 }) => {
    const { t } = useTranslation("common");

    const getUrl = (typeIcon) => {
        switch (typeIcon) {
            case "ICON_JUNIOR":
                return SuperSafariIcon;
            case "ICON_KIDS_BOX":
                return JuniorIcon;
            case "ICON_SUPER_SAFARI":
                return KidsBoxIcon;
            case "ICON_CAMBRIDGE":
                return CambridgeIcon;
            default:
                return "";
        }
    };

    const truncateWithTooltip = (text, maxLength = 15) => {
        if (!text) return "";
        const shouldTruncate = text.length > maxLength;
        const truncated = shouldTruncate ? text.slice(0, maxLength) + "..." : text;

        return <span title={shouldTruncate ? text : ""}>{truncated}</span>;
    };

    return (
        <div className="dashboard__card-slider">
            <Swiper
                modules={[Pagination]}
                pagination={{ el: ".swiper-pagination", clickable: true }}
                spaceBetween={20}
                slidesPerView={1}
                breakpoints={{
                    640: { slidesPerView: smallSlidesPerView },
                    1024: { slidesPerView: bigSlidesPerView },
                }}
            >
                {groups.map(group => (
                    <SwiperSlide key={group.id}>
                        <div className="dashboard__card-slider-item">
                            <div
                                className="dashboard__card-slider-item-img"
                                style={{ background: group.typeColor }}
                            >
                                {group.typeIcon && (
                                    <img src={getUrl(group.typeIcon)} alt={group.typeName} />
                                )}
                            </div>
                            {group.hasStarted !== undefined && (
                                <div className="dashboard__card-slider-item-badge">
                                    {group.hasStarted ? (
                                        <img src={BadgeApproved} alt="icon" />
                                    ) : (
                                        <img src={BadgeError} alt="icon" />
                                    )}
                                </div>
                            )}                            
                            <div className="dashboard__card-slider-item-title">
                                {truncateWithTooltip(group.name)}
                            </div>
                            <div className="dashboard__card-slider-item-name">
                                <span className="role">{t("groups.professor")}: </span>
                                <span className="name">{group.professorFullName}</span>
                            </div>
                        </div>
                    </SwiperSlide>
                ))}
                <div className="dashboard__card-slider-pagination swiper-pagination"></div>
            </Swiper>
        </div>
    );
};

export default CardGroups;
